// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Pause = function Pause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.76 2.5a.75.75 0 0 0-.75.75v13.5c0 .413.337.75.75.75h2.25c.412 0 .75-.337.75-.75V3.25a.75.75 0 0 0-.75-.75zm-2.25.75A2.25 2.25 0 0 1 4.76 1h2.25a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 7.01 19H4.76a2.25 2.25 0 0 1-2.25-2.25zm10.5-.75a.75.75 0 0 0-.75.75v13.5c0 .413.337.75.75.75h2.25c.412 0 .75-.337.75-.75V3.25a.75.75 0 0 0-.75-.75zm-2.25.75A2.25 2.25 0 0 1 13.01 1h2.25a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 15.26 19h-2.25a2.25 2.25 0 0 1-2.25-2.25z"
  }));
};
